import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../../store/slices/authSlice';
import ErrorLayout from '../components/ErrorLayout';
import { useThemeContext } from '../../../components/ThemeProvider';
import { useCommonTranslation } from '../../../hooks';

const Error401 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { primaryColor } = useThemeContext();
  const { t } = useCommonTranslation();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  const handleLogin = () => {
    navigate('/login', { replace: true });
  };

  return (
    <ErrorLayout
      code={401}
      title={t('errorPages.401.title')}
      message={t('errorPages.401.message')}
      action={
        <button 
          onClick={handleLogin}
          className="px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
          style={{ backgroundColor: primaryColor || '#1E40AF' }}
        >
          {t('errorPages.401.login')}
        </button>
      }
    />
  );
};

export default Error401;
